import i18n from 'i18next'

export default function renderYesNo(value?: string) {
  return value
    ? value.toLowerCase() === 'yes' || value.toLowerCase() === 'true'
      ? i18n.t('common.yes')
      : i18n.t('common.no')
    : ''
}
